import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { LoadingComponent } from './menu/loading/loading.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire/questionnaire.component';
import { IntroQuestionnaireService } from './questionnaire/intro-questionnaire.service';
import { TutorialComponent } from './tutorial/tutorial.component';
import { IsSetUgOptionPipe } from '../pipes/auth/IsSetUgOptionPipe';
import { IsSetSmile9UserSettingsPipe } from '../pipes/auth/IsSetSmile9UserSettingsPipe';
import { ReplaceToAsteriskPipe } from '../pipes/string/ReplaceToAsteriskPipe';
import { LoadLocalCsvComponent } from './csv/load-local-csv/load-local-csv.component';
import { OriginGridComponent } from './origin-grid/origin-grid.component';
import { TutorialKeepPropService } from './tutorial/tutorial.service';
import { TutorialHttpLogService } from './tutorial/tutorial-http.service';
import { GuideUrlLinkComponent } from './guide-url-link/guide-url-link.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjGridModule,
    WjInputModule,
    ReactiveFormsModule,
  ],
  exports: [
    LoadingComponent,
    QuestionnaireComponent,
    TutorialComponent,
    IsSetUgOptionPipe,
    IsSetSmile9UserSettingsPipe,
    ReplaceToAsteriskPipe,
    LoadLocalCsvComponent,
    OriginGridComponent,
    GuideUrlLinkComponent,
  ],
  declarations: [
    LoadingComponent,
    QuestionnaireComponent,
    TutorialComponent,
    IsSetUgOptionPipe,
    IsSetSmile9UserSettingsPipe,
    ReplaceToAsteriskPipe,
    LoadLocalCsvComponent,
    OriginGridComponent,
    GuideUrlLinkComponent,
  ],
  providers: [
    IntroQuestionnaireService,
    TutorialKeepPropService, 
    TutorialHttpLogService,
  ]
})
export class ShareModule { }
